var _switch;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.9 39.4c3.3 5.2 5.2 11.3 5.2 17.8 0 18.3-14.9 33.3-33.3 33.3-18.3 0-33.3-14.9-33.3-33.3s14.9-33.3 33.3-33.3c6.6 0 12.7 1.9 17.8 5.2l5-5c-6.5-4.5-14.4-7.2-22.9-7.2C20.6 16.9 2.5 35 2.5 57.2c0 22.2 18.1 40.3 40.3 40.3 22.2 0 40.3-18.1 40.3-40.3 0-8.5-2.6-16.4-7.2-22.9l-5 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9 32.8C52.7 30.4 48 29 42.8 29c-15.5 0-28.2 12.6-28.2 28.2s12.6 28.2 28.2 28.2C58.3 85.4 71 72.7 71 57.2c0-5.1-1.4-9.9-3.8-14.1L62 48.3c1.3 2.7 2 5.7 2 8.9 0 11.7-9.5 21.1-21.2 21.1s-21.1-9.5-21.1-21.1c0-11.7 9.5-21.2 21.1-21.2 3.2 0 6.2.7 8.9 2l5.2-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.4 48.3 6.3-6.3c-1.6-.5-3.2-.8-5-.8-8.8 0-16 7.2-16 16.1 0 8.8 7.2 16 16 16 8.9 0 16-7.2 16-16 0-1.7-.3-3.4-.8-4.9l-6.4 6.3c-.6 4.3-4.4 7.6-8.9 7.6-5 0-9-4.1-9-9 .2-4.6 3.5-8.4 7.8-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3 13.5c-.3-.8-1.1-1.3-1.9-1.3h-7.6V4.6c0-.9-.5-1.6-1.3-1.9-.8-.3-1.7-.1-2.3.5L74.4 13c-.4.4-.6.9-.6 1.5v6.9c-.1 0-.1.1-.2.1L40.3 54.7c-1.4 1.4-1.4 3.6 0 5 .7.7 1.6 1 2.5 1s1.8-.3 2.5-1l33.2-33.2c0-.1.1-.1.1-.2h6.9c.6 0 1.1-.2 1.5-.6l9.8-9.8c.7-.7.9-1.6.5-2.4z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.8f5db3ca8743db3dfa91e2d42a39b340.svg";
export { ForwardRef as ReactComponent };